import { isBrowser, isNode } from 'browser-or-node';
import riot from 'riot'

if (isBrowser) {

  window.addEventListener('load', () => {
    riot.update('*');
  }, false);
}
